import TwinAttributesSelector from '../twinAttributesSelector.vue';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
export default {
  name: 'TwinMapPopupEditor',
  components: {
    TwinAttributesSelector
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    popupTitle: {
      get() {
        const clone = cloneDeep(this.value);
        return get(clone, 'twinMapOptions.popupTitle', '');
      },
      set(val) {
        const clone = cloneDeep(this.value);
        set(clone, 'twinMapOptions.popupTitle', val);
        this.$emit('input', clone);
      }
    },
    twins() {
      return cloneDeep(get(this.data, 'twin-map', []));
    },
    attributes: {
      get() {
        return get(this.value, 'twinMapOptions.attributes', []);
      },
      set(val) {
        const clone = cloneDeep(this.value);
        set(clone, 'twinMapOptions.attributes', val);
        this.$emit('input', clone);
      }
    }
  }
};